import React, { Component } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import CodigoGeografico from "./CodigoGeografico";

class DomicilioCorrespondencia extends Component {
    constructor(props) {
        super(props)

        this.selectCombo = this.selectCombo.bind(this);
        this.guardarNovedades = this.guardarNovedades.bind(this);
    }
    /**
     * 
     * @param {any} novedades
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstados(estadoId, entidadId) {
        const codigoNovedades = ["DMBCO_CUEN", "DMCAL_CUEN", "DMNRO_CUEN", "DMDPT_CUEN", "DMLOD_CUEN", "DMCOP_CUEN", "DMCGE_CUEN", "DMCAR_CUEN", "DMTEL_CUEN"]

        const novedades = this.props.data.novedadesCuentaDatos.filter(ncd => codigoNovedades.some(cn => cn == ncd.NovedadCampoCodigo));
        this.props.actualizarNovedadEstados(novedades, estadoId, novedades[0].NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} valor Parametro string, indica el valor modificado
     * @param {any} codigoNovedad Parametro string, indica el codigo de la novedad a la cual modificar
     * @param {any} esOtro Parametro booleano opcion, indica si el valor que se esta modificando es otro y no un codigo geografico existente
     */
    changeInput(valor, codigoNovedad, esOtro = false) {
        this.props.changeInput(1, this.props.codigoNovedad, valor, esOtro, codigoNovedad);
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        let index = event.target.selectedIndex;
        let optionActual = event.target.options[index].dataset.codigo;

        this.props.selectCombo(1, this.props.codigoNovedad, event.target.value, optionActual);
    }
    /**
     * Arma un string formateado a como debe mostrarse la descripcion del domicilio
     * @param {any} cadenaOriginal
     * @param {any} codigoNovedad
     * @param {any} valorNovedad
     * @param {any} tieneFormato
     */
    armarDescripcionDomicilio(cadenaOriginal, codigoNovedad, valorNovedad, tieneFormato) {
        let formato = "#DMBCO_CUEN# - #DMCAL_CUEN#, #DMNRO_CUEN#, #DMDPT_CUEN#, #DMLOD_CUEN#, #DMCOP_CUEN#, (Cód. geográfico #DMCGE_CUEN#). (Telefono #DMCAR_CUEN# #DMTEL_CUEN#)";

        if (valorNovedad == undefined || valorNovedad == null) {
            valorNovedad = "";
        }

        if (tieneFormato) {
            return cadenaOriginal.replace(`#${codigoNovedad}#`, valorNovedad);
        } else {
            return formato.replace(`#${codigoNovedad}#`, valorNovedad);
        }
    }
    /**
     * 
     */
    guardarNovedades() {
        const { cuentaDatos } = this.props.data;
        const { DomicilioCorrespondencia2 } = cuentaDatos;

        let novedades = [
            { "Id": undefined, "Clave": "DMBCO_CUEN", "ValorAnterior": DomicilioCorrespondencia2.BancoTipo.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.BancoTipo.Valor },
            { "Id": undefined, "Clave": "DMCAL_CUEN", "ValorAnterior": DomicilioCorrespondencia2.Calle.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.Calle.Valor },
            { "Id": undefined, "Clave": "DMNRO_CUEN", "ValorAnterior": DomicilioCorrespondencia2.Numero.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.Numero.Valor },
            { "Id": undefined, "Clave": "DMDPT_CUEN", "ValorAnterior": DomicilioCorrespondencia2.DepartamentoPartido.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.DepartamentoPartido.Valor },
            { "Id": undefined, "Clave": "DMLOD_CUEN", "ValorAnterior": DomicilioCorrespondencia2.Lod.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.Lod.Valor },
            { "Id": undefined, "Clave": "DMCOP_CUEN", "ValorAnterior": DomicilioCorrespondencia2.CodigoPostal.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.CodigoPostal.Valor },
            { "Id": undefined, "Clave": "DMCGE_CUEN", "ValorAnterior": DomicilioCorrespondencia2.CodigoGeografico.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.CodigoGeografico.Valor },
            { "Id": undefined, "Clave": "DMCAR_CUEN", "ValorAnterior": DomicilioCorrespondencia2.Caracteristica.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.Caracteristica.Valor },
            { "Id": undefined, "Clave": "DMTEL_CUEN", "ValorAnterior": DomicilioCorrespondencia2.Telefono.ValorOriginal, "ValorNuevo": DomicilioCorrespondencia2.Telefono.Valor }
        ]

        this.props.guardarNovedades(novedades);
    }
    /**
     * 
     */
    render() {
        const { armarDescripcionDomicilio } = this;
        const { cuentaDatos, domiciliosService, funcionesDelUsuario, novedadesCuentaDatos, seEstaEditando } = this.props.data;

        const camposNovedadesDomicilio = [
            { Codigo: "DMBCO_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.BancoTipo.ValorOriginal },
            { Codigo: "DMCAL_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.Calle.ValorOriginal },
            { Codigo: "DMNRO_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.Numero.ValorOriginal },
            { Codigo: "DMDPT_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.DepartamentoPartido.ValorOriginal },
            { Codigo: "DMLOD_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.Lod.ValorOriginal },
            { Codigo: "DMCOP_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.CodigoPostal.ValorOriginal },
            { Codigo: "DMCGE_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.ValorOriginal },
            { Codigo: "DMCAR_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.Caracteristica.ValorOriginal },
            { Codigo: "DMTEL_CUEN", Valor: cuentaDatos.DomicilioCorrespondencia2.Telefono.ValorOriginal }
        ];
        /*no cambiar a arrow function, ya que el "this" es la base de los datos del objeto, de lo contrario este perderia sus valores y pasaria a formar parte de la clase*/
        cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.obtenerValor = function () {
            if (this.Novedad) {
                if (this.NovedadEditada) {
                    return this.Valor;
                }
                return this.Novedad.ValorNovedad;
            } else {
                return this.Valor;
            }
        }
        /*no cambiar a arrow function, ya que el "this" es la base de los datos del objeto, de lo contrario este perderia sus valores y pasaria a formar parte de la clase*/
        cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.actualizarNovedad = function () {
            if (novedadesDomicilio && novedadesDomicilio.length > 0) {
                this.Novedad = novedadesDomicilio.find(ncd => ncd.NovedadCampoCodigo == "DMCGE_CUEN");
            }
        }
        /*armo un array string con todos los campos de las novedades*/
        const codigosNovedad = camposNovedadesDomicilio.map((cn) => cn.Codigo);
        /*busco todas las novedades en base a los codigos obtenidos anteriormente*/
        const novedadesDomicilio = novedadesCuentaDatos.filter((novedad) => codigosNovedad.some((cn) => cn == novedad.NovedadCampoCodigo));

        let descDomi = "";
        let descDomiAnterior = "";
        let valorCodGeografico = cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.obtenerValor();
        let valorDomBanTipo = cuentaDatos.DomicilioCorrespondencia2.BancoTipo.Valor;
        let valorDomDepPar = cuentaDatos.DomicilioCorrespondencia2.DepartamentoPartido.Valor;
        let valorCodPostal = cuentaDatos.DomicilioCorrespondencia2.CodigoPostal.Valor;
        let optionsNodos = [];

        /*actualizo la novedad con las ultimas novedades*/
        cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.actualizarNovedad();

        /*pregunto si hay novedades para el domicilio*/
        if (novedadesDomicilio && novedadesDomicilio.length > 0) {
            /*armo la descripcion para mostrar en base a los datos de las novedades*/
            novedadesDomicilio.forEach((nov, index) => {
                descDomi = armarDescripcionDomicilio(descDomi, nov.NovedadCampoCodigo, nov.ValorNovedad, (index > 0))
                descDomiAnterior = armarDescripcionDomicilio(descDomiAnterior, nov.NovedadCampoCodigo, nov.ValorAnterior, (index > 0))
            });
            /*asumiendo que existe la novedad de codigo geografico, lo cual deberia ser cierto, asigno el valor anterior formateado la nueva descripcion*/
            cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.Novedad.ValorAnteriorFormateado = descDomiAnterior;
        } else {
            /*armo la descripcion para mostrar en base a los datos de la cuenta original, ya que no hay novedades*/
            camposNovedadesDomicilio.forEach((cvn, index) => {
                descDomi = armarDescripcionDomicilio(descDomi, cvn.Codigo, cvn.Valor, (index > 0));
            });
        }

        optionsNodos.push(
            <option value={cuentaDatos.DomicilioCorrespondencia2.BancoTipo.ValorOriginal}
                data-codigo={cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.ValorOriginal}
                key={"domi-base"}>{descDomi}</option>
        );

        if (domiciliosService) {
            domiciliosService.filter(ds => ds.CodigoDomicilio != cuentaDatos.DomicilioCorrespondencia2.BancoTipo.ValorOriginal).map((ds, index) => {
                const descripcionSer = (ds.CodigoDomicilio) ?
                    ds.CodigoDomicilio + " - "
                    + ds.Calle + ', '
                    + ds.Numero + ', '
                    + ds.Localidad + ', '
                    + ds.CodigoPostal + '. (Telefono: ' + (ds.Telefono.Caracteristica != "" ? ds.Telefono.Caracteristica + '-' : "")
                    + ds.Telefono.Numero + ')' : ds.Calle;

                optionsNodos.push(
                    <option value={ds.CodigoDomicilio} data-codigo={ds.CodigoDomicilio} key={"domi-" + index}>
                        {descripcionSer}
                    </option>
                );
            });
        }
        else {
            /*si falló el ws*/
            optionsNodos.push(<option>FALLO WEBSERVICE</option>)
        }
        /*armo el componente*/
        const componenteDomicilio = (
            <div>
                <select className="form-control default-select" onChange={this.selectCombo} value={valorDomBanTipo}>
                    {optionsNodos}
                </select>

                <CodigoGeografico data={this.props.data} partido={valorDomDepPar}
                    valorCodGeografico={valorCodGeografico}
                    valorCodPostal={valorCodPostal}
                    objCodigoGeo={cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico}

                    changeInput={(valor, esOtro) => this.changeInput(valor, "DMCGE_CUEN", esOtro)}
                />
            </div>
        );

        return (
            <div>
                <GenericEditPanel
                    componente={componenteDomicilio}
                    cuenta={cuentaDatos}
                    permisoUsuario={funcionesDelUsuario}
                    novedad={cuentaDatos.DomicilioCorrespondencia2.CodigoGeografico.Novedad}
                    seEstaEditando={seEstaEditando}
                    textPanel={descDomi || "Sin especificar"}
                    title="Domicilio para correspondencia"
                    value={valorCodGeografico}

                    aceptChanges={this.guardarNovedades}
                    confirmarNovedad={() => this.actualizarNovedadEstados(2, cuentaDatos.CuentaTarjetaId)}
                    changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                    denegarNovedad={() => this.actualizarNovedadEstados(3, cuentaDatos.CuentaTarjetaId)}
                    mostrarModificaciones={this.props.mostrarModal}
                    revert={this.props.cancelar}
                />
            </div>
        );
    }
}

export default DomicilioCorrespondencia;